/* eslint-disable max-len */
import 'react';

const CoptToBtnSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_2128_50782" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
            <rect width="20" height="20" fill="black" />
        </mask>
        <g mask="url(#mask0_2128_50782)">
            <path d="M14.9999 2.70801C16.2654 2.70801 17.2917 3.73354 17.2919 4.99902V12.083C17.2917 13.3485 16.2654 14.374 14.9999 14.374H13.9589V15.416C13.9589 16.6817 12.9325 17.708 11.6669 17.708H4.58386C3.31821 17.708 2.29187 16.6817 2.29187 15.416V8.33301C2.29187 7.06736 3.31821 6.04102 4.58386 6.04102H5.62488V4.99902C5.62507 3.73354 6.65134 2.70801 7.91687 2.70801H14.9999ZM4.58386 7.29102C4.00857 7.29102 3.54187 7.75771 3.54187 8.33301V15.416C3.54187 15.9913 4.00857 16.458 4.58386 16.458H11.6669C12.2422 16.458 12.7089 15.9913 12.7089 15.416V8.33301C12.7089 7.75771 12.2422 7.29102 11.6669 7.29102H4.58386ZM7.91687 3.95801C7.34169 3.95801 6.87507 4.42389 6.87488 4.99902V6.04102H11.6669C12.9325 6.04102 13.9589 7.06736 13.9589 8.33301V13.124H14.9999C15.5751 13.124 16.0417 12.6582 16.0419 12.083V4.99902C16.0417 4.42389 15.5751 3.95801 14.9999 3.95801H7.91687Z" fill="#3377FF" />
        </g>
    </svg>

);
export default CoptToBtnSvg;
